import { GridColDef } from '@mui/x-data-grid';
import Tooltip from '@mui/material/Tooltip';
import { formatTime } from '@Utils/formatTime';
import { ExtendedGridColDef } from '@Types/ExtendedGridColDef';
import { paymentMethodTypeValues } from '@Types/Payment';
import { ISession } from '@Types/Sessions';
import CopyColumn from '@Components/table/CopyColumn';

export const sessionsColumns: (GridColDef<ISession> & ExtendedGridColDef)[] = [
  {
    field: 'subAreaId',
    headerName: 'Subarea ID',
    hideable: false,
    flex: 0.1,
    renderCell: (params) => {
      return <CopyColumn value={params.value} />;
    },
    valueGetter: (params) => `${params.row.subAreaId}`,
  },
  {
    field: 'paymentMethodType',
    headerName: 'Payment Method',
    hideable: false,
    flex: 0.1,
    renderCell: (params) => {
      const value = params.value;

      return <Tooltip title={value}>{value}</Tooltip>;
    },
    valueGetter: (params) =>
      (paymentMethodTypeValues as any)[params.row.paymentMethodType],
  },
  {
    field: 'timestamp',
    headerName: 'Settled Date',
    hideable: false,
    flex: 0.1,
    renderCell: (params) => {
      const dateStr = params.value;

      return (
        <Tooltip title={dateStr}>
          <span className='table-cell-truncate'>{dateStr}</span>
        </Tooltip>
      );
    },
    valueGetter: (params) => formatTime(params.row.timestamp),
  },
  {
    field: 'createdAt',
    headerName: 'Date',
    hideable: false,
    flex: 0.1,
    renderCell: (params) => {
      const dateStr = params.value;

      return (
        <Tooltip title={dateStr}>
          <span className='table-cell-truncate'>{dateStr}</span>
        </Tooltip>
      );
    },
    valueGetter: (params) => formatTime(params.row.createdAt),
  },
  {
    field: 'licensePlateNumber',
    headerName: 'VRM/VRN',
    hideable: false,
    flex: 0.1,
    renderCell: (params) => {
      return (
        <Tooltip title={params.value}>
          <span className='table-cell-truncate'>{params.value}</span>
        </Tooltip>
      );
    },
    valueGetter: (params) => params.row.licensePlateNumber,
  },
  {
    field: 'amount',
    headerName: 'Amount',
    hideable: false,
    flex: 0.1,
    renderCell: (params) => {
      return (
        <Tooltip title={params.value}>
          <span className='table-cell-truncate'>{params.value}</span>
        </Tooltip>
      );
    },
    valueGetter: (params) => `£${params.row.amount?.toFixed(2)}`,
  },
  {
    field: 'subareaName',
    headerName: 'Subarea Name',
    hideable: false,
    flex: 0.1,
    renderCell: (params) => {
      return (
        <Tooltip title={params.value}>
          <span className='table-cell-truncate'>{params.value}</span>
        </Tooltip>
      );
    },
    valueGetter: (params) => params.row.subAreaName,
  },
  {
    field: 'status',
    headerName: 'Status',
    hideable: false,
    flex: 0.1,
    renderCell: (params) => {
      return (
        <Tooltip title={params.value}>
          <span
            className='table-cell-truncate'
            style={{ textTransform: 'capitalize' }}
          >
            {params.value}
          </span>
        </Tooltip>
      );
    },
    valueGetter: (params) => params.row?.status?.toLowerCase(),
  },
  {
    field: 'type',
    headerName: 'Type',
    hideable: false,
    flex: 0.1,
    renderCell: (params) => {
      const value = params.value;

      return (
        <Tooltip title={value}>
          <span className='table-cell-truncate'>{value}</span>
        </Tooltip>
      );
    },
    valueGetter: (params) => params.row?.type,
  },
  {
    field: 'timeZoneId',
    headerName: 'Time Zone',
    hideable: false,
    flex: 0.2,
    renderCell: (params) => {
      const value = params.value;

      return (
        <Tooltip title={value}>
          <span className='table-cell-truncate'>{value}</span>
        </Tooltip>
      );
    },
    valueGetter: (params) => params.row.timeZoneId,
  },
];
